import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.dom-exception.stack.js";
import BillingService from '@/services/BillingService';
import Loading from '@/components/widget/Loading';
import BillingForm from '@/components/billing/Form';
export default {
  components: {
    Loading,
    BillingForm
  },
  props: {
    type: {
      type: String,
      default: 'add'
    },
    btnColor: {
      type: String,
      default: 'success'
    },
    btnSize: {
      type: String,
      default: 'sm'
    },
    billingrecord: {
      type: Object,
      default() {
        return null;
      }
    },
    address: {
      type: Object,
      default() {
        return null;
      }
    },
    states: Array,
    countries: Array
  },
  data: () => {
    return {
      modalstate: false,
      loading: false,
      form: {
        billing: {
          valid: false
        },
        billingAddress: {
          valid: false
        }
      }
    };
  },
  methods: {
    setBilling(data) {
      this.form = Object.assign({}, data);
    },
    prepData() {
      const data = {
        info: this.form.billing,
        address: this.form.billingAddress,
        save: {
          address: 1,
          info: 1
        }
      };
      const tmp = data.info.name.split(/\s+/);
      data.info.firstname = tmp.shift();
      data.info.lastname = tmp.join(' ');
      data.info.number = btoa(data.info.number);
      data.info.cvc = btoa(data.info.cvc);
      return data;
    },
    updateBilling(e) {
      if (e) {
        e.preventDefault();
      }
      if (this.loading) {
        return false;
      }
      if (!this.form.billing.valid && this.form.billing.cardedit && this.form.billing.cardedit > 0 || !this.form.billingAddress.valid) {
        alert('Your card information is invalid. Please try again.');
        return false;
      }

      // Explicitly check for missing required fields
      const requiredFields = ['address1', 'zip', 'city', 'state_id', 'country_id'];
      const missingFields = requiredFields.filter(field => !this.form.billingAddress[field]);
      if (missingFields.length > 0) {
        // Alert the developer in real-time (optional)
        // this.sendErrorToMonitoringService('Billing address validation failed', {
        //  missingFields,
        //  billingAddress: this.form.billingAddress
        // })
        // Display a message on-screen
        const response = {
          data: {
            header: 'Warning!',
            success: [],
            error: ['Your billing address is incomplete. The following fields are missing: ' + missingFields.map(field => field.replace(/_/g, ' ')).join(', ') + '.']
          }
        };
        this.$aim.error(response);
        return false;
      }

      // Let's see what's being passed in
      // this.sendErrorToMonitoringService('Billing address validation PASSED', {
      //   billing: this.form.billing,
      //   billingAddress: this.form.billingAddress,
      //   prepData: this.prepData()
      // })

      // Proceed with submission only if everything is valid
      this.loading = true;
      BillingService.save(this.prepData()).then(response => {
        this.$emit('refresh');
        this.$aim.notify(response);
        this.$nextTick(() => {
          this.$bvModal.hide('credit-card-modal');
        });
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    },
    sendErrorToMonitoringService(message, details) {
      const data = {
        message,
        details
      };
      BillingService.alertdev(data).then(response => {
        console.log('Remote logging successful.');
      }).catch(error => {
        console.error('Failed to log error remotely:', error.response);
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};